var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloperModeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    viewBox: "0 0 73 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0597 9.9845H12.3404V13.2884H9.0597V9.9845Z",
    fill: "black",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6216 9.9845H20.9023V13.2884H17.6216V9.9845Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.183 9.9845H29.4637V13.2884H26.183V9.9845Z",
    fill: "black",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2227 5.17354V4.67354H68.7227H4.27734H3.77734V5.17354V18.0993V18.5993H4.27734H68.7227H69.2227V18.0993V5.17354ZM3.77734 61.4046V61.9046H4.27734H68.7227H69.2227V61.4046V22.4032V21.9032H68.7227H4.27734H3.77734V22.4032V61.4046ZM0.5 65.2085V1.36963H72.5V65.2085H0.5Z",
    fill: "black",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7442 41.5952L21.5033 41.9032L21.7442 42.2112L29.4152 52.0208L26.838 54.0613L17.3298 41.9032L26.838 29.745L29.4152 31.7856L21.7442 41.5952Z",
    fill: "black",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2558 42.2112L51.4967 41.9032L51.2558 41.5952L43.5848 31.7856L46.162 29.745L55.6702 41.9032L46.162 54.0613L43.5848 52.0208L51.2558 42.2112Z",
    fill: "black",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8613 29.4841H38.1387V54.3233H34.8613V29.4841Z",
    fill: "black",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperModeIcon);
export default __webpack_public_path__ + "static/media/developerModeIcon.10fe0fefba33d5eb18c42a343a01a1f5.svg";
export { ForwardRef as ReactComponent };